"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
var _cookies = require("@kiwicom/cookies");
var _handleSessionId = _interopRequireDefault(require("./services/handleSessionId"));
var _ids = require("./ids");
var _handleAffiliateId = _interopRequireDefault(require("./services/handleAffiliateId"));
var _handleDeeplinkId = _interopRequireDefault(require("./services/handleDeeplinkId"));
var _handleUTMs = _interopRequireDefault(require("./services/handleUTMs"));
const init = () => {
  const {
    affilId,
    affilid,
    // deprecated format, force 'affilId'
    deeplinkId,
    ...rest
  } = _queryString.default.parse(window.location.search);
  return {
    // TODO drop this eventually
    // noone should be depending on visitor id from nitro session and maybe nitro session in general
    // a bit hard to do right now because every FE uses nitro session init
    // so would be a bit messy to expect everyone to go through that usage
    userId: (0, _cookies.load)(_cookies.Cookie.USER_ID) || "",
    sessionId: (0, _handleSessionId.default)(),
    pageViewId: (0, _ids.makePageViewId)(),
    deeplinkId: (0, _handleDeeplinkId.default)(deeplinkId && String(deeplinkId)),
    affiliate: (0, _handleAffiliateId.default)((affilId || affilid) && String(affilId || affilid), rest),
    UTMs: (0, _handleUTMs.default)(rest)
  };
};
var _default = exports.default = init;